/**
 * Create a URL-friendly slug from a stall name, preserving & and '
 */
export function makeStallSlug(name) {
  if (!name) return '';
  return name
    .trim()
    .toLowerCase()
    .replace(/\s+/g, '-')
    .replace(/[^a-z0-9\-&']/g, '')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '');
}

/**
 * Build the share URL for a stall using its slug
 */
export function getStallShareUrl(stall) {
  const slug = makeStallSlug(stall.stallName);
  return `https://wayo.co.za/api/stalls/${slug}/share`;
}
